export const FEE_STATUS_LABELS = {
  not_required: "No Payment Required",
  awaiting_payment: "Awaiting Payment",
  payment_submitted: "Payment Submitted",
  verification_pending: "Pending Verification",
  verified: "Verified",
  payment_not_found: "Payment Not Found",
  incorrect_amount: "Incorrect Amount",
  partially_paid: "Partially Paid",
  waived: "Waived",
  refunded: "Refunded",
  cancelled: "Cancelled",
};

export const FEE_STATUS_COLORS = {
  not_required: "bg-soft-gray text-midnight-black/70",
  awaiting_payment: "bg-stranger-orange text-clean-white",
  payment_submitted: "bg-stranger-orange text-clean-white",
  verification_pending: "bg-stranger-orange text-clean-white",
  verified: "bg-midnight-black text-clean-white",
  payment_not_found: "bg-red-100 text-red-700",
  incorrect_amount: "bg-red-100 text-red-700",
  partially_paid: "bg-stranger-orange text-clean-white",
  waived: "bg-soft-gray text-midnight-black/70",
  refunded: "bg-soft-gray text-midnight-black/70",
  cancelled: "bg-soft-gray text-midnight-black/70",
};

export const feeStatusLabel = (status) => FEE_STATUS_LABELS[status] || status;
export const feeStatusColor = (status) => FEE_STATUS_COLORS[status] || "bg-soft-gray text-midnight-black/70";

export const formatMoney = (amount) => `$${Number(amount ?? 0).toFixed(2)}`;
